module.exports = __webpack_public_path__ + "img/demo-booking-right-info.e34d88ce.png";